






import Vue from "vue";

export default Vue.extend({
  name: "TheAboutPage",

  mounted() {
    Vue.set(this.$root.$data, "title", "Impressum");
  },

  data: () => ({
    //
  })
});
